import { primeResultsDataSchema } from "./primeResultsDataSchema";
import { primeProtocolDataSchema } from "../protocol/primeProtocolDataSchema";

export const ctisResultsDataSchema = {
  type: "object",
  properties: {
    protocol: primeProtocolDataSchema.properties.protocol,
    results: primeResultsDataSchema.properties.results
  }
}